goog.provide("shadow.js.shim.module$$mui$material$Fade$default");
shadow.js.shim.module$$mui$material$Fade$default = shadow.js.shim.module$$mui$material$Fade.default;
